module.exports = __webpack_public_path__ + "img/portrait-094.a3af8078.jpg";